import styled, { css, keyframes } from 'styled-components';
import detail from './components/chartImage/img/detail.png';

const fadeIn = keyframes`
	0% {	opacity: 0;}
	50% {	opacity: 0;}
	100% {	opacity: 1;}
`;

interface Props {
  showModalDiscount: boolean;
}

export const PaymentModalDiscount = styled.div<Pick<Props, 'showModalDiscount'>>`
  border-radius: 24px 24px 0 0;
  width: 100%;
  height: 100%;
  // min-height: 100vh;
  min-height: auto;
  padding-top: 48px;
  background-color: #f2ede1;
  max-width: 470px;
  z-index: ${({ showModalDiscount }) => (showModalDiscount ? 30 : -1)};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: ${({ showModalDiscount }) => (showModalDiscount ? 'relative' : 'absolute')};
  opacity: 0;
  animation: ${({ showModalDiscount }) =>
    showModalDiscount
      ? css`
          ${fadeIn} 0.2s 0.1s ease both
        `
      : 'none'};

  body.dark & {
    background: #181716;
  }
`;

export const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: none;

  img {
    width: 16px;
    min-width: 16px;
  }

  body.dark & {
    background: #2e2c2a;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const Margined = styled.div`
  margin: 0 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: overlay;
  // transform: translateY(60%);
`;

export const CloseArea = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
  background: #e0dfe7;
  transition: opacity 0.25s ease-out;
`;

export const ModalWindowContainer = styled.div`
  margin: 20px auto auto;
  padding-bottom: 60px;
  width: 100%;
  max-width: 470px;
  height: 200vh;
  position: relative;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: white;
  z-index: 2;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 21px;
`;

export const Title = styled.h2`
  color: #231e19;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 19px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.076px;
  padding: 0 20px;

  body.dark & {
    color: #fffbf1;
  }
`;

export const Wrapper = styled.div`
  padding-bottom: 16px;
  width: 100%;
  border-radius: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ChartWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  animation: ${fadeIn} 0.2s 0.1s ease both;
`;

export const ChartContainer = styled.div`
  position: relative;
  height: auto;
  width: 100%;
`;

export const Description = styled.div`
  margin-top: -10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 36px;

  p {
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 14.045px;
    font-weight: 700;
    line-height: 16.051px;
    letter-spacing: 0.056px;
  }

  p:nth-child(1) {
    color: #7b766f;
  }

  p:nth-child(2) {
    color: #00a36f;
  }
`;

export const Bubble2 = styled.div`
  border-radius: 21.067px;
  background: linear-gradient(251deg, #00a36f 16.17%, #c3d300 168.85%, #ff8d00 321.52%), #00a470;
  color: #fffbf1;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 10.032px;
  font-weight: 700;
  line-height: 16.051px;
  letter-spacing: 0.04px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 10px;
  position: absolute;
  top: 27px;
  right: 36px;
`;

export const Bubble3 = styled.div`
  border-radius: 21.067px;
  background: linear-gradient(0deg, #f9c885 0%, #f9c885 100%), #00a470;
  color: #fffbf1;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 10.032px;
  font-weight: 700;
  line-height: 16.051px;
  letter-spacing: 0.04px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  white-space: nowrap;
  position: absolute;
  top: 31vw;
  right: 36px;

  @media (min-width: 470px) {
    top: 143px;
  }

  body.dark & {
    background: #847152;
  }
`;

export const Offer = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 32px 32px 0px 0px;
  background: #fffbf1;
  box-shadow: 0px 0px 40px 0px rgba(153, 148, 138, 0.2);
  margin-top: auto;

  h4 {
    color: #231e19;
    text-align: center;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 28px;
    font-weight: 700;
    line-height: 34px;
    letter-spacing: -0.4px;
    margin-bottom: 8px;

    body.dark & {
      color: #fffbf2;
    }
  }

  body.dark & {
    background: #2a2928;
	box-shadow: none;
  }
`;

export const OfferImg = styled.img`
  width: 202px;
  margin-bottom: 10px;
`;

export const OfferText = styled.p`
  color: #7b766f;
  text-align: center;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;

  body.dark & {
    color: #fffbf2;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  width: 100%;

  p {
    padding: 0 40px;
  }
`;
